import Base from "../components/layout/clients/Base";
import ClientsGridView from "../components/layout/clients/ClientsGridView";
import Dashboard from "../components/layout/project/Dashboard";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { isExpired, decodeToken } from "react-jwt";
import { useEffect, useState } from "react";
import CreateClient from "../components/layout/clients/CreateClient";
import EditClient from "../components/layout/clients/EditClient";
import ClientProfile from "../components/layout/clients/ClientProfile";
import Login from "../components/layout/login/Login";
import { isLoggedIn } from "../utils/helpers/auth.helpers";
import TermsAndConditions from "../components/layout/login/TermsAndConditions";

function RoutesClients() {
    const Navigate = useNavigate();
    const myDecodedToken = decodeToken(localStorage.getItem("token"));
    const isMyTokenExpired = isExpired(localStorage.getItem("token"));
    const location = useLocation();
    const [shouldRedirectLogin, setShouldRedirectLogin] = useState(true)
    


    useEffect(() => {
        if (
            !isMyTokenExpired &&
            window.location.href !== `${process.env.REACT_APP_BASE_URL}`
        ) {
            sessionStorage.setItem("id", myDecodedToken.user.id);
            sessionStorage.setItem("name", myDecodedToken.user.fullName.first);
        }
    });

    useEffect(() => {
        
        if (
            location.pathname !== `/` &&
            location.pathname !==`/registration` &&
            location.pathname !==`/forgotPassword` &&
            location.pathname !==`/termsAndConditions`&&
            location.pathname !==`/2faPage`&&
            // location.pathname !==`/createBestPractice`&&
            !location.pathname.includes(`/projectInvite`)&&
            !location.pathname.includes(`/directory`)&&
            !location.pathname.includes(`/passwordReset`)&&
            !location.pathname.includes(`/publicClientQuestionnaire`)
        ) {
            // setShouldRedirectLogin(true)
            // setShouldRedirectLogin(true)
            isLoggedIn(setShouldRedirectLogin)
        }
    });

    // console.log(location.pathname)
    // console.log(isLoggedIn())
    useEffect(() => {
        if (!shouldRedirectLogin) {
            // console.log("Hello")
            console.log("window: ", window.location.href);
            console.log("process", process.env.REACT_APP_BASE_URL);
            Navigate("/");
        }
    }, [shouldRedirectLogin])

    return (
        <Routes>
            {/* <Route
        exact
        path="/clients/profile/:id"
        element={<Base adminView={true} mainContent={<ClientProfile />} />}
      /> */}
            {/* <Route exact path="/" element={<Login />} /> */}
            {/* <Route exact path="/termsAndConditions" element={<TermsAndConditions/>} /> */}
            
            <Route path="/clients/profile/:id" element={<Dashboard />}>
                <Route index element={<ClientProfile />} />
            </Route>

            {/* <Route
          exact
          path="/clients"
          element={
            <Base
              adminView={true}
              mainContent={<ClientsGridView adminView={true} />}
            />
          }
        /> */}

            <Route path="/clients" element={<Dashboard />}>
                <Route index element={<ClientsGridView />} />
            </Route>

            <Route path="/clients/new" element={<Dashboard />}>
                <Route index element={<CreateClient />} />
            </Route>
            <Route path="/clients/edit/:id" element={<Dashboard />}>
                <Route index element={<EditClient />} />
            </Route>
        </Routes>
    );
}

export default RoutesClients;
